import React, { useEffect } from 'react';
import useI18n from 'hooks/use-i18n';
import {
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import { Search } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { getHeaderTextSearch, setHeaderTextSearch } from 'store/search';
import { useUser } from '../../../hooks';
import Router from 'next/router';
import PropsTypes from 'prop-types';
import { isIOS, isMobile } from 'react-device-detect';

const HeaderSearchPagination = ({ className, placeholder }) => {
  const i18n = useI18n();
  const { query } = useRouter();
  const user = useUser();
  const textSearch = useSelector(getHeaderTextSearch);
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.settingAccount.metaData);

  const enterSearch = async () => {
    if (metaData?.cmsHomePage) {
      textSearch.length && Router.push(user?._id ? '/course' : '/homes/course');
    } else {
      textSearch.length &&
        Router.push(user?._id ? '/course/courseGrid' : '/homes/course');
    }
  };

  const onEnterPress = (e) => {
    e.key === 'Enter' && enterSearch();
  };

  useEffect(() => {
    // if (query?.textSearch) {
    //   dispatch(setHeaderTextSearch(query.textSearch));
    // }
    return () => {
      dispatch(setHeaderTextSearch(''));
    };
  }, []);

  return (
    <>
      <div className="search-active">
        <InputGroup
          className={`${
            className === 'announcement'
              ? `input-group-merge header__input-group mx-0 pt-0 pb-0 `
              : `round input-group-merge header__input-group mx-0 pt-0 pb-0 ${className}`
          }`}
        >
          <InputGroupAddon addonType="prepend">
            <InputGroupText
              size="sm"
              className="cursor-search"
              onClick={enterSearch}
              style={{
                ...(isMobile && isIOS ? { fontSize: 16 } : {}),
              }}
            >
              <Search size={14} />
            </InputGroupText>
          </InputGroupAddon>
          <Input
            placeholder={placeholder || i18n.t('header.search')}
            value={textSearch.trimStart()}
            onChange={(e) => dispatch(setHeaderTextSearch(e.target.value))}
            onKeyDown={(e) => onEnterPress(e)}
          />
        </InputGroup>
      </div>
    </>
  );
};

HeaderSearchPagination.prototype = {
  className: PropsTypes.string,
};

export default HeaderSearchPagination;
